/**
 * Countries offered at sign-up, with their currency and measurement default.
 * The country also picks the cell (ARCHITECTURE.md §3.3); at launch every one
 * of these lives in us1.
 */
export interface CountryOption {
  code: string;
  name: string;
  currency: string;
  units: "imperial" | "metric";
}

export const COUNTRIES: CountryOption[] = [
  { code: "US", name: "United States", currency: "USD", units: "imperial" },
  { code: "CA", name: "Canada", currency: "CAD", units: "metric" },
];

export function guessCountry(): CountryOption {
  const region = new Intl.Locale(navigator.language).maximize().region;
  return COUNTRIES.find((c) => c.code === region) ?? COUNTRIES[0]!;
}

export function timeZones(): string[] {
  try {
    return Intl.supportedValuesOf("timeZone");
  } catch {
    return [Intl.DateTimeFormat().resolvedOptions().timeZone];
  }
}
